import _createBrowserHistory from './createBrowserHistory';
export { _createBrowserHistory as createBrowserHistory };
import _createHashHistory from './createHashHistory';
export { _createHashHistory as createHashHistory };
import _createMemoryHistory from './createMemoryHistory';
export { _createMemoryHistory as createMemoryHistory };

export { createLocation, locationsAreEqual } from './LocationUtils';
export { parsePath, createPath } from './PathUtils';


//////////////////
// WEBPACK FOOTER
// ./node_modules/history/es/index.js
// module id = 11
// module chunks = 0